import { SectionContent } from 'app/views/presentations/models/sectionContent.model';

export type TemperatureUnit = 'C' | 'F';

export class WeatherModel extends SectionContent {
    constructor(
        public temperatureUnit: TemperatureUnit = 'C',
        public weatherDuration: number = 20000,
        public cities: string[] = []
    ) {
        super();
    }
}


// WEBPACK FOOTER //
// ./src/app/views/presentations/models/weather.model.ts